"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.connectMerger = undefined;

var _lodash = require("lodash");

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var connectMerger = exports.connectMerger = function connectMerger(stateProps, dispatchProps, ownProps) {
	return _.merge({}, ownProps, stateProps, dispatchProps);
};